import React, { Component } from "react";
import { Link } from "react-router-dom";

class NavDropDown extends Component {
  onClick = link => e => {
    if (link.id) {
      e.preventDefault();
      const elmnt = document.getElementById(link.id);
      elmnt.scrollIntoView({
        alignToTop: false,
        behavior: "smooth"
      });
    }
    if (link.href) {
      e.preventDefault();
      window.location = link.href;
    }
    if (link.links) {
      this.setState({ showDropdown: !this.state.showDropdown });
    }
  };
  render() {
    return (
      <ul className={this.props.open ? "navDropDown open" : "navDropDown"}>
        {this.props.links.map((link, i) => (
          <li key={i}>
            <Link to={link.url || ""} key={i} onClick={this.onClick(link)}>
              {link.text}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
}

export default NavDropDown;
